/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable import/named */
import React, { useState, useEffect } from 'react';

import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { useHistory } from 'react-router';
import { pure } from 'recompose';
import styled from 'styled-components';

import { toggleOverlay } from 'actions/overlay';
import ClickOutside from 'components/click-outside';
import { TradeFeeCreditPopover } from 'components/trade_fee_credits';
import { OVERLAY_TYPES } from 'constants/constants';
import routes from 'constants/routes';
import { ShowFeeCreditSection } from 'helpers/formulas';
import { values, contains } from 'helpers/ramda';
import { device } from 'helpers/screenSizes';
import { conversionConfigSelector } from 'selectors';
import {
  ChevronDownIcon,
  Wallet,
  DepositIcon,
  ConvertIocn,
  CircleTradeIcon,
  DetailsArrow,
  WithDrawIcon,
} from 'styles/assets/icons';

import CoinIcon from '../../coin_selector';
import { disableScrolling, enableScrolling } from './get_change';

const CoinDropdownOptionsWrapper = styled.div`
  min-width: 540px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  background-color: ${props => props.theme.dropDownBackground};
  position: absolute;
  right: -4px;
  margin-top: 4px;
  padding: 16px 20px 2px 20px;
  @media ${device.down.md} {
    min-width: 356px;
    right: -86px;
    padding: 8px 12px 8px 12px;
  }

  z-index: 5;

  .flex {
    display: flex;
  }

  .balance-header {
    font-size: 12.1px;
    color: ${props => props.theme.secondaryText};
    font-family: var(--fontRegular);
    text-align: right;
    margin-bottom: 10px;
    padding: 10px 15px 0px;
  }

  .balance-row {
    background-color: ${props => props.theme.secondaryBackground};
    font-size: 12.1px;
    line-height: 1.5;
    letter-spacing: 0.6px;
    color: ${props => props.theme.secondaryText};
    margin: 0px 0px 14px;
    height: 90px;
    padding: 10px 5px;
  }

  .center-align {
    text-align: center;
  }

  .icon {
    text-align: center;
    margin-top: -1px;

    svg path {
      fill: ${props => props.theme.secondaryText};
    }
  }

  .action-icon {
    height: 12px;
    width: 12px;
  }

  .convert-icon-col {
    padding-right: 3px;
    padding-left: 2px;
  }

  .action-convert-icon {
    height: 12px;
    width: 12px;
    margin-top: -2px;
  }

  .flex {
    display: flex;
  }

  .label {
    color: ${props => props.theme.secondaryText};
    font-family: var(--fontRegular);
  }

  .balances {
    padding: 6px 2px 6px;
    margin-left: 1.9rem;
    &:nth-of-type(2) {
      padding-top: 10px;
    }

    @media ${device.down.md} {
      margin-left: 1rem;
      padding: 3px 1px 3px;
    }
  }

  .coin-column {
    color: ${props => props.theme.primaryText};
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      padding-right: 5px;
    }
    &::after {
      border-right: 1px solid ${props => props.theme.separator};
      content: '';
      position: absolute;
      right: -12%;
      height: 85%;
    }
  }

  .view-details {
    color: ${props => props.theme.primaryTheme};
    text-align: right;
    span {
      padding-left: 0.25rem;
      svg {
        margin-top: -1px;
      }
    }
  }

  .view-details:hover {
    cursor: pointer;
  }

  .action-icon {
    height: 15px;
    width: 15px;
    margin-top: -2px;

    path {
      fill: ${props => props.theme.primaryText};
    }
  }

  .action-icon:hover {
    cursor: pointer;
  }

  .convert-icon-col {
    padding-right: 0px;
    padding-left: 20px;
  }

  .action-convert-icon {
    height: 15px;
    width: 15px;
    margin: -2px 2px 0px -2px;
  }

  .action {
    text-align: center;
    color: ${props => props.theme.secondaryText};
  }

  .flex {
    display: flex;
  }

  .convert {
    display: flex;
    cursor: pointer;
  }

  .deposit-row {
    text-align: left;
    cursor: pointer;
  }

  .balance-action-label {
    padding-left: 5px;
    color: #a3a6aa;
    &.convert-label {
      padding-left: 2px;
    }

    @media ${device.down.md} {
      padding-left: 0.25rem;
    }
  }

  .fee-credit {
    background-color: #131c26;
    margin-top: 0.5rem;
    padding: 5px 5px 5px 5px;

    .fee-credit-label {
      display: inline-block;
      color: ${props => props.theme.secondaryText};
      font-family: var(--fontRegular);
    }

    .fee-credit-value {
      display: inline-block;
      color: #c7cacc;
      margin-left: 0.5rem;
    }

    @media ${device.down.md} {
      margin-top: 0.5rem;
      padding: 0.125rem 0.25rem;
    }
  }

  .other-balance-value {
    padding-left: 16px;
    color: #ffffff;
  }
  .wallet-dropdown-row {
    border-radius: 2px;
    background-color: #131c26;
  }
`;

const TotalBalanceWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media ${device.down.lg} {
    padding: 0px !important;
  }

  @media ${device.down.xs} {
    border-left: 2px solid ${props => props.theme.primaryBackground};
  }

  .dropdown {
    outline: none;
    max-height: 47px;
  }

  .wallet {
    cursor: pointer;
    text-align: center;
  }
`;

const ActionFactory = ({
  history,
  isWithdrawStatusEnabled,
  isDepositStatusEnabled,
  isConversionEnabled,
  openCurrencyConverterPopup,
  coin,
}) => {
  const navigateDeposit = () => {
    enableScrolling();
    history.push(`${routes.account.deposit}/${coin}`);
  };
  const navigateWithdrawal = () => {
    enableScrolling();
    history.push(`${routes.account.withdrawal}/${coin}`);
  };
  const tradeDeto = () => {
    enableScrolling();
    history.push(`${routes.spot.trade}/DETO/`);
  };
  const currenctConverterPopup = () => openCurrencyConverterPopup(coin);

  return (
    (<div className="d-flex deposit-row" data-palette="ActionFactory">
      {isDepositStatusEnabled && (
        <div
          data-testid="navigate-deposit"
          aria-hidden="true"
          className="col-8"
          onClick={navigateDeposit}
          data-palette="ActionFactory">
          <DepositIcon color="#FFFFFF" width={16} height={16} className="action-icon" />
          <span className="balance-action-label">Deposit</span>
        </div>
      )}
      {isWithdrawStatusEnabled && (
        <div
          data-testid="navigate-withdrawal"
          aria-hidden="true"
          className="col-8"
          onClick={navigateWithdrawal}
          data-palette="ActionFactory">
          <WithDrawIcon color="#FFFFFF" width={16} height={16} className="action-icon" />
          <span className="balance-action-label">Withdraw</span>
        </div>
      )}
      {isConversionEnabled && (
        <div
          data-testid="conversion-enabled"
          aria-hidden="true"
          className={classnames({
            'col-8 convert-icon-col': isDepositStatusEnabled && isWithdrawStatusEnabled,
            'col-12':
              (!isDepositStatusEnabled && isWithdrawStatusEnabled) ||
              (isDepositStatusEnabled && !isWithdrawStatusEnabled),
            'col-24': !isDepositStatusEnabled && !isWithdrawStatusEnabled,
          })}
          onClick={currenctConverterPopup}
          data-palette="ActionFactory">
          <ConvertIocn className="action-convert-icon" width={16} height={16} />
          <span className="balance-action-label convert-label">Convert</span>
        </div>
      )}
      {!isConversionEnabled && (
        <div
          data-testid="conversion-disabled"
          aria-hidden="true"
          className="col-8 convert-icon-col trade-icon-col"
          onClick={tradeDeto}
          data-palette="ActionFactory">
          <CircleTradeIcon className="action-trade-icon" width="13px" height="13px" />
          <span className="balance-action-label">Trade</span>
        </div>
      )}
    </div>)
  );
};

// todo-h: Create a new PR to refactor/rewrite this file and related code completely.

const CoinDropdownOptions = pure(
  ({
    open,
    balances,
    history,
    openCurrencyConverterPopup,
    toggleDropdown,
    total,
    available,
    selectedProduct,
  }) => {
    const conversionConfig = useSelector(state => conversionConfigSelector(state));
    const convertiableAsset = conversionConfig.convertible_assets;
    const dataBalances = values(balances).map(balance => ({
      id: `${balance.asset.symbol}`,
      asset_id: `${balance.asset.id}`,
      coin: `${balance.asset.symbol}`,
      balance: `${balance.balance}`,
      position_margin: `${balance.position_margin}`,
      order_margin: `${balance.order_margin}`,
      available_balance: `${balance.available_balance}`,
      trading_fee_credit: `${balance.trading_fee_credit}`,
      minimum_precision: `${balance.asset.minimum_precision}`,
      maximum_precision: `${balance.asset.maximum_precision}`,
      isDepositStatusEnabled: balance.asset.deposit_status === 'enabled',
      isWithdrawStatusEnabled: balance.asset.withdrawal_status === 'enabled',
      isConversionEnabled: contains(balance.asset.symbol, convertiableAsset),
    }));
    const disableFeeCredit = ShowFeeCreditSection(dataBalances);
    const getPrecision = (value, item) => {
      return Number(value).toFixed(item.minimum_precision);
    };
    //    const [currentView, setView] = useState('listView');
    //   const isTradingTerminal = window.location.pathname.indexOf('/trade/') > -1;

    return (
      (<CoinDropdownOptionsWrapper>
        {dataBalances.map((item, index) => (
          <div
            key={item.asset_id}
            className="d-flex balance-row wallet-dropdown-row"
            data-palette="CoinDropdownOptions">
            <div className="col-xxs-4 coin-column">
              <span className={`icon ${item.coin}`}>
                <CoinIcon coin={item.coin} />
              </span>
              <span>{item.coin}</span>
            </div>
            <div className="col-xxs-20">
              <div className="d-flex balances">
                <div className="col-xxs-10 col-md-13">
                  <span className="label">Total</span>
                  <span className="other-balance-value">
                    {Number.isNaN(Number(item.balance))
                      ? '-'
                      : Number(item.balance).toFixed(item.minimum_precision)}
                  </span>
                </div>
                <div className="col-xxs-14 col-md-11 available-balance-value">
                  <span className="label">Available</span>
                  <span className="other-balance-value">
                    {Number.isNaN(Number(item.available_balance))
                      ? '-'
                      : getPrecision(item.available_balance, item)}
                  </span>
                </div>
                {disableFeeCredit && (
                  <div className="fee-credit" data-palette="CoinDropdownOptions">
                    <span className="fee-credit-label">
                      Fee Credit
                      <TradeFeeCreditPopover
                        shouldDisablePortal
                        feeCredit={item.trading_fee_credit}
                      />
                    </span>
                    <span className="fee-credit-value">
                      {Number.isNaN(Number(item.trading_fee_credit))
                        ? '-'
                        : Number(item.trading_fee_credit).toFixed(item.minimum_precision)}
                    </span>
                  </div>
                )}
              </div>
              <div className="d-flex balances">
                <div className="col-md-18 col-xxs-16 action">
                  <ActionFactory
                    coin={item.coin}
                    isWithdrawStatusEnabled={item.isWithdrawStatusEnabled}
                    isDepositStatusEnabled={item.isDepositStatusEnabled}
                    isConversionEnabled={item.isConversionEnabled}
                    history={history}
                    openCurrencyConverterPopup={openCurrencyConverterPopup}
                  />
                </div>
                <div
                  data-testid="view-details"
                  aria-hidden="true"
                  className="col-md-6 col-xxs-8 view-details"
                  onClick={() => {
                    toggleDropdown();
                    enableScrolling();
                    history.push(
                      `${routes.account.balances}?s=${item.coin}&id=${item.asset_id}`
                    );
                  }}
                >
                  <span>
                    Details
                    <DetailsArrow />
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </CoinDropdownOptionsWrapper>)
    );
  }
);

const TotalCointDetails = styled.div`
  color: ${props => props.theme.primaryText};
  font-size: 12.1px;
  min-height: 52px;
  cursor: pointer;
  padding: 6px 5px 8px 5px;
  background-color: ${props =>
    props.open ? props.theme.primaryBackground : 'transparent'};

  @media ${device.down.lg} {
    font-size: 11px;
  }

  @media ${device.down.xs} {
    padding: 0px;
  }

  .label {
    color: ${props => props.theme.secondaryText};
    font-family: var(--fontRegular);
  }

  .coin {
    margin-top: 11px;
    display: flex;
    justify-content: center;
    padding-right: 8px;

    svg {
      rect {
        fill: ${props => props.theme.separator};
      }
    }
  }

  .ta-right {
    text-align: right;
  }

  .main-icon {
    display: flex;
    justify-content: center;
    padding-right: 5px;

    svg {
      margin-top: 10px !important;
      width: 18px;
      height: 18px;
      path {
        fill: ${props => props.theme.secondaryText};
      }
    }
  }

  .wallet {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
  }

  .balance-value {
    color: ${props => props.theme.secondaryText};
  }
`;

const DetailsText = styled.span`
  color: ${props => props.theme.secondaryText};
`;

const TotalCoinDetail = ({
  total,
  available,
  selectedProduct,
  toggleDropdown,
  open,
  minimum_precision,
}) => {
  const history = useHistory();
  const getSymbol = (() => {
    if (selectedProduct) {
      const { contract_type } = selectedProduct;
      const symbol =
        contract_type === 'spot'
          ? selectedProduct.underlying_asset.symbol
          : selectedProduct.settling_asset.symbol;
      return symbol;
    }
  })();

  return (
    <>
      <MediaQuery query={device.up.md}>
        <TotalCointDetails
          data-testid="v8izrIKsLiHHRZaoFKQ8P"
          open={open}
          className="d-flex"
          onClick={toggleDropdown}
        >
          <div className="col-xs-4 main-icon">
            <CoinIcon coin={getSymbol} />
          </div>
          <div className="col-xs-17">
            <div className="d-flex total-coin-amount">
              <DetailsText className="col-11 label">Total : </DetailsText>
              <div className="col-13 balance-value">
                {Number.isNaN(Number(total))
                  ? '-'
                  : Number(total).toFixed(minimum_precision)}
              </div>
            </div>
            <div className="d-flex total-coin-available">
              <DetailsText className="col-11 label"> Available : </DetailsText>
              <div className="col-13 balance-value">
                {Number.isNaN(Number(total))
                  ? '-'
                  : Number(available).toFixed(minimum_precision)}
              </div>
            </div>
          </div>
          <div className="col-xs-3 coin">
            <ChevronDownIcon />
          </div>
        </TotalCointDetails>
      </MediaQuery>
      <MediaQuery query={device.down.md}>
        <div
          data-testid="Lxyyc1W0bm-TI3EVOCj-Y"
          aria-hidden="true"
          className="wallet"
          onClick={() => history.push(routes.account.balances)}
        >
          <Wallet />
        </div>
      </MediaQuery>
    </>
  );
};

export const TotalBalance = props => {
  const [open, toggle] = useState(false);
  const dispatch = useDispatch();

  const _toggleOverlay = val => {
    dispatch(
      toggleOverlay({
        overlayType: OVERLAY_TYPES.BALANCE_MENU,
        value: val,
      })
    );
  };

  useEffect(() => {
    return () => _toggleOverlay(false);
    // eslint-disable-next-line
  }, []);

  const onOptionsBlur = () => {
    toggle(false);
    _toggleOverlay(false);
    enableScrolling();
  };

  const toggleDropdown = () => {
    open ? enableScrolling() : disableScrolling();
    _toggleOverlay(!open);
    toggle(!open);
  };

  const minimum_precision = () => {
    if (!props.selectedProduct) {
      return 4;
    }
    if (props.selectedProduct.contract_type === 'spot') {
      return props.selectedProduct.underlying_asset.minimum_precision;
    }
    return props.selectedProduct.settling_asset.minimum_precision;
  };

  return (
    <TotalBalanceWrapper>
      <ClickOutside onOutsideClick={onOptionsBlur} tabIndex="5" className="dropdown">
        <TotalCoinDetail
          total={props.total}
          available={props.available}
          selectedProduct={props.selectedProduct}
          toggleDropdown={toggleDropdown}
          open={open}
          minimum_precision={minimum_precision()}
        />
        {open && (
          <CoinDropdownOptions
            toggleDropdown={toggleDropdown}
            balances={props.balances}
            history={props.history}
            total={props.total}
            available={props.available}
            selectedProduct={props.selectedProduct}
            open={open}
            openCurrencyConverterPopup={props.openCurrencyConverterPopup}
          />
        )}
      </ClickOutside>
    </TotalBalanceWrapper>
  );
};
